import React from "react";
import { company } from "../mock";

const steps = (name) => [
  { t: "Free inspection & written estimate", d: "We inspect your home, document what we find with photos, and give you a clear written estimate before any work begins." },
  { t: "Honest recommendation", d: `We explain your ${name.toLowerCase()} options, materials and financing. If storm damage is involved, we help you file and manage the insurance claim.` },
  { t: "Professional installation", d: "Licensed, insured crews complete the work on schedule, protecting your landscaping and keeping you updated at every step." },
  { t: "Clean-up & warranty", d: "We clean up thoroughly and back every project with our workmanship guarantee and manufacturer warranties." },
];

const ServiceExplainer = ({ svc }) => (
  <section className="bg-white py-16" data-testid="service-explainer">
    <div className="max-w-5xl mx-auto px-6">
      <h2 className="font-display font-extrabold text-brand-navy text-2xl md:text-3xl mb-8">
        How {svc.name} Works with Fab Build Pro
      </h2>
      <ol className="grid sm:grid-cols-2 gap-5">
        {steps(svc.name).map((s, i) => (
          <li key={s.t} className="bg-brand-cream rounded-2xl p-6 border border-black/5">
            <span className="font-display font-extrabold text-brand-orange text-lg">{i + 1}.</span>
            <h3 className="font-display font-bold text-brand-navy text-lg mt-1 mb-2">{s.t}</h3>
            <p className="text-slate-600 text-sm leading-relaxed">{s.d}</p>
          </li>
        ))}
      </ol>
      <h2 className="font-display font-extrabold text-brand-navy text-2xl md:text-3xl mt-12 mb-3">
        Where We Offer {svc.name}
      </h2>
      <p className="text-slate-600 leading-relaxed">
        Fab Build Pro is a roofing and general contractor based at {company.address}. We provide{" "}
        {svc.name.toLowerCase()} throughout Northern Virginia — including Fairfax County, Arlington,
        Alexandria, Loudoun County and Prince William County — as well as Washington, D.C. and Maryland
        communities such as Rockville, Hyattsville and Frederick. Call {company.phone} for a free estimate.
      </p>
    </div>
  </section>
);

export default ServiceExplainer;
